import React, { useState } from "react";
import {
  displayAvailabilityDateUnitNameText,
  formatDate,
} from "../../../../../Helper_functions";
import AnonymousIcon from "../../../../../Assets/Images/Anonymous.svg";

const AvailabilityModal = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  const handleUnavailableData = (Data) => {
    if (Data === "" || Data === null || Data === undefined) {
      return translateText("not_available");
    } else {
      return Data;
    }
  };
  return (
    <div className="contact-modal">
      <div className="outline" onClick={() => props.Close()}></div>
      <div className="contact-modal-body">
        <>
          {props.IsJPA ? (
            <section className="modal-head">
              <section className="candidate-identity">
                <p className="candidate-name">{props.Availability?.title}</p>
                <p className="candidate-pos">{props.Availability?.location}</p>
              </section>
              <i className="feather-x" onClick={() => props.Close()}></i>
            </section>
          ) : (
            <>
              {props.ApplicationType === "ANONYMOUS" ? (
                <section className="modal-head">
                  <img
                    className="avatar avatar-image"
                    src={AnonymousIcon}
                    style={{ background: "#dde2eb", border: "none" }}
                  />
                  <section className="candidate-identity">
                    <p className="candidate-name">
                      {translateText("anonymous")}
                    </p>
                    <p className="candidate-pos">
                      {props.Candidate.currentPositionTitle}
                    </p>
                  </section>
                  <i className="feather-x" onClick={() => props.Close()}></i>
                </section>
              ) : (
                <section className="modal-head">
                  {props.Candidate.imageThumbnailUrl === null ? (
                    <span
                      className="avatar"
                      style={{
                        backgroundColor: props.Candidate.backgroundColorCode,
                      }}
                    >
                      <p style={{ color: props.Candidate.textColorCode }}>
                        {props.Candidate.firstName.slice(0, 1).toUpperCase() +
                          props.Candidate.lastName.slice(0, 1).toUpperCase()}
                      </p>
                    </span>
                  ) : (
                    <img
                      className="avatar avatar-image"
                      src={props.Candidate.imageThumbnailUrl}
                    />
                  )}
                  <section className="candidate-identity">
                    <p className="candidate-name">
                      {props.Candidate.firstName +
                        " " +
                        props.Candidate.lastName}
                    </p>
                    <p className="candidate-pos">
                      {props.Candidate.currentPositionTitle}
                    </p>
                  </section>
                  <i className="feather-x" onClick={() => props.Close()}></i>
                </section>
              )}
            </>
          )}
        </>
        <section className="contact-info-content">
          <div className="contact-row">
            <img alt="" src={props.Icon} />
            <section className="small-info">
              <p>{translateText("availability")}</p>
              <p>
                {handleUnavailableData(props.Availability?.value) +
                  " " +
                  displayAvailabilityDateUnitNameText(
                    props.Availability?.unit,
                    props.LangData
                  )}
              </p>
            </section>
          </div>
          <div className="contact-row">
            <i className="feather-calendar"></i>
            <section className="small-info">
              <p>{translateText("start_date")}</p>
              <p>
                {props.Availability?.startDate ? (
                  <>{formatDate(props.Availability?.startDate)}</>
                ) : (
                  translateText("not_available")
                )}
              </p>
            </section>
          </div>
          <div className="contact-row">
            <i className="feather-calendar"></i>
            <section className="small-info">
              <p>{translateText("end_date")}</p>
              <p>
                {props.Availability?.endDate ? (
                  <>{formatDate(props.Availability?.endDate)}</>
                ) : (
                  translateText("not_available")
                )}
              </p>
            </section>
          </div>
        </section>
        <section className="contact-actions">
          <span className="cancel send-mail" onClick={() => props.Close()}>
            <p>{translateText("close")}</p>
          </span>
        </section>
      </div>
    </div>
  );
};

export default AvailabilityModal;
